import React from "react";
import clsx from "clsx";

interface CheckboxProps {
  id?: string;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark';
  label?: string;
  labelClassName?: string;
  name: string;
  checked: boolean;
  className?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, name: string) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
  id, variant, label, labelClassName, name, checked, className, disabled, onChange
}) => {
  return (
    <div className={clsx("form-check", `form-check-${variant || 'primary'}`, className)}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        className="form-check-input"
        onChange={(e) => onChange && onChange(e, name)}
        data-testid={`checkbox-${String(name).toLowerCase()}`}
      />
      {label && <label htmlFor={id} className={clsx("form-check-label", labelClassName)}>{label}</label>}
    </div>

  );
};

export default Checkbox;